import { render } from "./Media.vue?vue&type=template&id=f20e6488&scoped=true&ts=true"
import script from "./Media.vue?vue&type=script&lang=ts"
export * from "./Media.vue?vue&type=script&lang=ts"

import "./Media.vue?vue&type=style&index=0&id=f20e6488&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f20e6488"]])

export default __exports__